import { CognitoUserPool } from "amazon-cognito-identity-js";

const poolData = {
  UserPoolId: String(process.env.REACT_APP_COGNITO_USER_POOL_ID),
  ClientId: String(process.env.REACT_APP_COGNITO_CLIENT_ID),
};
export default new CognitoUserPool(poolData);
